// src/pages/LandingPage.js
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./LandingPage.css";

export default function LandingPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const leafRef = useRef([]);

  useEffect(() => {
    if (user) navigate("/dashboard");
  }, [user, navigate]);

  return (
    <div className="landing-root">
      {/* Background video */}
      <video
        className="landing-video"
        autoPlay
        muted
        loop
        playsInline
        onError={(e) => {
          e.target.style.display = "none";
        }}
      >
        <source src="/videos/fog.mp4" type="video/mp4" />
      </video>

      {/* Fallback gradient when no video */}
      <div className="landing-gradient-bg" />

      {/* Floating particles */}
      <div className="particles">
        {[...Array(18)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${6 + Math.random() * 8}s`,
              width: `${4 + Math.random() * 8}px`,
              height: `${4 + Math.random() * 8}px`,
            }}
          />
        ))}
      </div>

      {/* Overlay */}
      <div className="landing-overlay" />

      {/* Content */}
      <div className="landing-content">
        {/* Logo ring */}
        <div className="logo-ring">
          <div className="logo-inner">
            <div className="logo-icon">🍚</div>
          </div>
          <svg className="logo-circle" viewBox="0 0 120 120">
            <circle
              cx="60"
              cy="60"
              r="54"
              fill="none"
              stroke="rgba(74,222,128,0.4)"
              strokeWidth="1.5"
              strokeDasharray="4 3"
            />
            <circle
              cx="60"
              cy="60"
              r="46"
              fill="none"
              stroke="rgba(74,222,128,0.2)"
              strokeWidth="1"
            />
          </svg>
        </div>

        {/* Title */}
        <h1 className="landing-title">
          <span className="title-main">ಅಕ್ಷರ ದಾಸೋಹ</span>
          <span className="title-sub">ನಿರ್ವಹಣಾ ವ್ಯವಸ್ಥೆ</span>
        </h1>

        <p className="landing-desc">
          ಮಧ್ಯಾಹ್ನ ಉಪಹಾರ ಯೋಜನೆ · ಪ್ರಧಾನ ಮಂತ್ರಿ ಪೋಷಣ್ ಅಭಿಯಾನ
        </p>

        <div className="landing-divider">
          <span />
          <span className="divider-leaf">✦</span>
          <span />
        </div>

        {/* CTA Button */}
        <button className="landing-btn" onClick={() => navigate("/login")}>
          <span className="btn-text">ಪ್ರಾರಂಭಿಸಿ</span>
          <span className="btn-sub">Let's Go →</span>
          <div className="btn-shine" />
        </button>

        {/* Bottom info */}
        <div className="landing-footer-info">
          <div className="info-pill">📚 ತರಗತಿ ೧-೧೦</div>
          <div className="info-pill">🥗 ದೈನಂದಿನ ಊಟ</div>
          <div className="info-pill">📊 ವರದಿ</div>
        </div>
      </div>
    </div>
  );
}
